import React, { useContext, useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { ConfigurationContext } from "../../contexts";

/** Testing progress.
 *  Monitors the tests context and shows progress.
 */
export const Status = (props) => {
  //  const { tests } = useContext(TestsContext);
  //  const { testCount } = tests;
  //  const { targetIndex } = props;
  const { localTestTime } = useContext(ConfigurationContext);
  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {
    // Update the start time just once.
    setStartTime(Date.now());
  }, []);

  /** Calculate the percent of the tests done.
   */
  const percent = () => {
    const elapsedTime = Date.now() - startTime;
    //    let p = Math.trunc((tests.times[targetIndex].length / 50) * 100);
    let p = Math.trunc((elapsedTime / localTestTime) * 100);
    return p > 95 ? 100 : p; // If the percent is over 95 just show 100.
  };

  /** Render.
   */

  return (
    <>
      <ProgressBar striped variant='success' now={percent()} label={`${percent()}%`} />
    </>
  );
};
